import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Typography, Box } from "@mui/material";
import { firestore } from "../firebase.config";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import PageNavBar from "../components/PageNavBar";
import TenantBanner from "../components/TenantBanner";
// import { BannerAd } from "../components/ads/Ads";

const leaveTypes = [
  "Sick Leave",
  "Maternity Leave",
  "Paternity Leave",
  "Privileged Leave",
  "Casual Leave",
  "Other",
];

const ApplyLeave = () => {
  const [leaveType, setLeaveType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [tenantId, setTenantId] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (currentUser) {
      setUserEmail(currentUser.email);

      const fetchUserDetails = async () => {
        const userDocRef = doc(firestore, "Users", currentUser.email);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setTenantId(userData.tenantId || "");
        }
      };

      fetchUserDetails();
    }
  }, []);

  const handleApplyLeave = async () => {
    if (!userEmail) {
      alert("User is not logged in");
      return;
    }

    const leaveData = {
      leaveType,
      startDate,
      endDate,
      remarks,
      status: "Pending",
      user: userEmail,
      tenantId: tenantId,
    };

    const uniqueDocId = `${userEmail}_${Date.now()}`;

    try {
      await setDoc(doc(firestore, "leaves", uniqueDocId), leaveData);
      alert("Leave application submitted!");
      setLeaveType("");
      setStartDate("");
      setEndDate("");
      setRemarks("");
    } catch (error) {
      console.error("Error applying for leave:", error);
      alert("Failed to submit leave application.");
    }
  };

  return (
    <Box sx={{ 
      background: "linear-gradient(135deg, #3b82f6 0%, #7c3aed 50%, rgb(231, 58, 237) 100%)",
      minHeight: "100vh",
      width: "100%",
      margin: 0,
      padding: 0,
      position: "relative"
    }}>
      <PageNavBar title="Apply Leave" backTo="/dashboard" />
      <TenantBanner />
      
      <Box sx={{ p: 3, mt: 2, maxWidth: 500, mx: "auto" }}>
        
        {/* White Box around the form */}
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            p: 3,
            mb: 3 // Added margin bottom for spacing
          }}
        >
          <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>Apply for Leave</Typography>
          <Box component="form" noValidate autoComplete="off">
            <TextField
              select
              label="Leave Type"
              value={leaveType}
              onChange={(e) => setLeaveType(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
            >
              {leaveTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              type="date"
              label="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              type="date"
              label="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              fullWidth
              multiline
              rows={4}
              sx={{ mb: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleApplyLeave}
              fullWidth
              sx={{ mt: 2 }}
            >
              Apply
            </Button>
          </Box>
        </Box>

        {/* <BannerAd /> */}

      </Box>
    </Box>
  );
};

export default ApplyLeave;
